// src/features/live/panels/TopLiveCreatorsPanel.tsx — right-rail creators with
// a working Follow. Thin wrapper around the shared CreatorsPanel (slice-4-xl
// S4 — this used to duplicate Videos' TopCreatorsPanel byte-for-byte).
import { CreatorsPanel } from '@/components/CreatorsPanel/CreatorsPanel';
import type { LiveCreator } from '@/core/models/live';

export interface TopLiveCreatorsPanelProps {
  creators: LiveCreator[];
}

export function TopLiveCreatorsPanel({ creators }: TopLiveCreatorsPanelProps) {
  return <CreatorsPanel title="Top Live Creators" creators={creators} />;
}
